import usegetdata from '../../Hooks/useGetData';
import { Get_All_Top_Saler_by_monthyear, Get_Error } from '../Types';

export const Get_All_Top_Saller_By_MonthYear_Action = (year, month) => async (dispatch) => {
  try {
    const res = await usegetdata(
      `/api/v1/users/sales-performance-monthyear?year=${year}&month=${month}`,
    );
    dispatch({
      type: Get_All_Top_Saler_by_monthyear,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};
